var map = {
	"./ActivityLogs/ActivityLogs": [
		67939,
		5810,
		7939
	],
	"./ActivityLogs/ActivityLogs.tsx": [
		67939,
		5810,
		7939
	],
	"./ActivityLogs/components/Column": [
		56119,
		6119
	],
	"./ActivityLogs/components/Column.tsx": [
		56119,
		6119
	],
	"./ActivityLogs/components/Logs": [
		36804,
		5810,
		6804
	],
	"./ActivityLogs/components/Logs.tsx": [
		36804,
		5810,
		6804
	],
	"./Analytics/Analytics": [
		18872,
		6679,
		9683,
		4520,
		8872
	],
	"./Analytics/Analytics.tsx": [
		18872,
		6679,
		9683,
		4520,
		8872
	],
	"./Analytics/components/AnalyticsPanel": [
		80272,
		272
	],
	"./Analytics/components/AnalyticsPanel.tsx": [
		80272,
		272
	],
	"./Analytics/components/BarChart": [
		31875,
		9683,
		1875
	],
	"./Analytics/components/BarChart.tsx": [
		31875,
		9683,
		1875
	],
	"./Analytics/components/Breakdown": [
		32922,
		2922
	],
	"./Analytics/components/Breakdown.tsx": [
		32922,
		2922
	],
	"./Analytics/components/Gridlayout": [
		82876,
		2876
	],
	"./Analytics/components/Gridlayout.tsx": [
		82876,
		2876
	],
	"./Analytics/components/PaymentLinkSummary": [
		21270,
		1270
	],
	"./Analytics/components/PaymentLinkSummary.tsx": [
		21270,
		1270
	],
	"./Analytics/components/PieTransactionSummary": [
		54862,
		9683,
		4862
	],
	"./Analytics/components/PieTransactionSummary.tsx": [
		54862,
		9683,
		4862
	],
	"./Analytics/components/SalesLineChart": [
		4520,
		6679,
		9683,
		4520
	],
	"./Analytics/components/SalesLineChart.tsx": [
		4520,
		6679,
		9683,
		4520
	],
	"./Analytics/store/service": [
		56391,
		6391
	],
	"./Analytics/store/service.ts": [
		56391,
		6391
	],
	"./Auth/ForgotPassword": [
		77451,
		6286,
		7451
	],
	"./Auth/ForgotPassword.tsx": [
		77451,
		6286,
		7451
	],
	"./Auth/Login": [
		59618,
		4270,
		6286,
		9618
	],
	"./Auth/Login.tsx": [
		59618,
		4270,
		6286,
		9618
	],
	"./Auth/Otp": [
		43273,
		681,
		6286,
		3273
	],
	"./Auth/Otp.tsx": [
		43273,
		681,
		6286,
		3273
	],
	"./Auth/Register": [
		26036,
		4570,
		4270,
		2809,
		6286,
		6036
	],
	"./Auth/Register.tsx": [
		26036,
		4570,
		4270,
		2809,
		6286,
		6036
	],
	"./Auth/ResetPassword": [
		40756,
		6286,
		756
	],
	"./Auth/ResetPassword.tsx": [
		40756,
		6286,
		756
	],
	"./Auth/SendVerifyEmail": [
		15922,
		6286,
		5922
	],
	"./Auth/SendVerifyEmail.tsx": [
		15922,
		6286,
		5922
	],
	"./Auth/VerifyEmail": [
		81756,
		1756
	],
	"./Auth/VerifyEmail.tsx": [
		81756,
		1756
	],
	"./Auth/components/AnalyticsScriptCode": [
		51497,
		4270,
		1497
	],
	"./Auth/components/AnalyticsScriptCode.tsx": [
		51497,
		4270,
		1497
	],
	"./Auth/components/ForgotPasswordModal": [
		43957,
		3957
	],
	"./Auth/components/ForgotPasswordModal.tsx": [
		43957,
		3957
	],
	"./Auth/components/SnapPixelCode": [
		56225,
		4270,
		6225
	],
	"./Auth/components/SnapPixelCode.tsx": [
		56225,
		4270,
		6225
	],
	"./Auth/components/SnapPixelHelper": [
		67177,
		7177
	],
	"./Auth/components/SnapPixelHelper.ts": [
		67177,
		7177
	],
	"./Auth/components/TwitterConversionCode": [
		51979,
		4270,
		1979
	],
	"./Auth/components/TwitterConversionCode.tsx": [
		51979,
		4270,
		1979
	],
	"./Auth/store/authSlice": [
		80101
	],
	"./Auth/store/authSlice.ts": [
		80101
	],
	"./Auth/store/service": [
		10334
	],
	"./Auth/store/service.tsx": [
		10334
	],
	"./Customer/Customer": [
		98298,
		5810,
		9715,
		8298
	],
	"./Customer/Customer.tsx": [
		98298,
		5810,
		9715,
		8298
	],
	"./Customer/CustomerTransaction": [
		2820,
		5810,
		2820
	],
	"./Customer/CustomerTransaction.tsx": [
		2820,
		5810,
		2820
	],
	"./Customer/components/Column": [
		88053,
		8053
	],
	"./Customer/components/Column.tsx": [
		88053,
		8053
	],
	"./Customer/components/CustomerTable": [
		35178,
		5810,
		5178
	],
	"./Customer/components/CustomerTable.tsx": [
		35178,
		5810,
		5178
	],
	"./Customer/store/service": [
		27361,
		7361
	],
	"./Customer/store/service.tsx": [
		27361,
		7361
	],
	"./Dashboard/Dashboard": [
		44849,
		5810,
		9683,
		829,
		4849
	],
	"./Dashboard/Dashboard.tsx": [
		44849,
		5810,
		9683,
		829,
		4849
	],
	"./Dashboard/components/BarChart": [
		93764,
		9683,
		3764
	],
	"./Dashboard/components/BarChart.tsx": [
		93764,
		9683,
		3764
	],
	"./Dashboard/components/Column": [
		60591,
		591
	],
	"./Dashboard/components/Column.tsx": [
		60591,
		591
	],
	"./Dashboard/components/FiatWallet": [
		65201,
		5201
	],
	"./Dashboard/components/FiatWallet.tsx": [
		65201,
		5201
	],
	"./Dashboard/components/PendngTasks": [
		70412,
		412
	],
	"./Dashboard/components/PendngTasks.tsx": [
		70412,
		412
	],
	"./Dashboard/components/RecentTransaction": [
		20999,
		5810,
		999
	],
	"./Dashboard/components/RecentTransaction.tsx": [
		20999,
		5810,
		999
	],
	"./Dashboard/components/TwoFactor": [
		33888,
		3888
	],
	"./Dashboard/components/TwoFactor.tsx": [
		33888,
		3888
	],
	"./Dashboard/store/dashboardSlice": [
		95295
	],
	"./Dashboard/store/dashboardSlice.ts": [
		95295
	],
	"./Dashboard/store/service": [
		22230
	],
	"./Dashboard/store/service.ts": [
		22230
	],
	"./FiatPayout/FiatPayout": [
		22122,
		5810,
		681,
		829,
		1210,
		7562,
		5153,
		2122
	],
	"./FiatPayout/FiatPayout.tsx": [
		22122,
		5810,
		681,
		829,
		1210,
		7562,
		5153,
		2122
	],
	"./FiatPayout/FiatPayoutDetail": [
		9261,
		9261
	],
	"./FiatPayout/FiatPayoutDetail.tsx": [
		9261,
		9261
	],
	"./FiatPayout/components/Column": [
		29743,
		9743
	],
	"./FiatPayout/components/Column.tsx": [
		29743,
		9743
	],
	"./FiatPayout/components/PayoutModal": [
		87692,
		829,
		7562,
		7389
	],
	"./FiatPayout/components/PayoutModal.tsx": [
		87692,
		829,
		7562,
		7389
	],
	"./FiatPayout/components/PreferredAccount": [
		7209,
		7209
	],
	"./FiatPayout/components/PreferredAccount.tsx": [
		7209,
		7209
	],
	"./FiatPayout/store/service": [
		90961,
		961
	],
	"./FiatPayout/store/service.tsx": [
		90961,
		961
	],
	"./GetStarted/GetStarted": [
		95948,
		3678,
		8409
	],
	"./GetStarted/GetStarted.tsx": [
		95948,
		3678,
		8409
	],
	"./GetStarted/components/ApiDocs": [
		24355,
		4355
	],
	"./GetStarted/components/ApiDocs.tsx": [
		24355,
		4355
	],
	"./GetStarted/components/ExploreVideoCard": [
		6563,
		6563
	],
	"./GetStarted/components/ExploreVideoCard.tsx": [
		6563,
		6563
	],
	"./GetStarted/components/KycTaskCard": [
		40274,
		6297
	],
	"./GetStarted/components/KycTaskCard.tsx": [
		40274,
		6297
	],
	"./GetStarted/components/PricingCard": [
		1608,
		1608
	],
	"./GetStarted/components/PricingCard.tsx": [
		1608,
		1608
	],
	"./GetStarted/components/TestTokens": [
		31556,
		1556
	],
	"./GetStarted/components/TestTokens.tsx": [
		31556,
		1556
	],
	"./GetStarted/components/TwoFactorCard": [
		97341,
		7341
	],
	"./GetStarted/components/TwoFactorCard.tsx": [
		97341,
		7341
	],
	"./GetStarted/components/VideoListCard": [
		60181,
		181
	],
	"./GetStarted/components/VideoListCard.tsx": [
		60181,
		181
	],
	"./GetTokens/GetTokens": [
		86317,
		7692,
		5717,
		178,
		7039
	],
	"./GetTokens/GetTokens.tsx": [
		86317,
		7692,
		5717,
		178,
		7039
	],
	"./GetTokens/service": [
		71334,
		1334
	],
	"./GetTokens/service.tsx": [
		71334,
		1334
	],
	"./GetTokens/walkthrough/Walkthrough1": [
		54749,
		9012
	],
	"./GetTokens/walkthrough/Walkthrough1.js": [
		54749,
		9012
	],
	"./GetTokens/walkthrough/Walkthrough10": [
		97049,
		7049
	],
	"./GetTokens/walkthrough/Walkthrough10.js": [
		97049,
		7049
	],
	"./GetTokens/walkthrough/Walkthrough2": [
		33141,
		5042
	],
	"./GetTokens/walkthrough/Walkthrough2.js": [
		33141,
		5042
	],
	"./GetTokens/walkthrough/Walkthrough3": [
		66825,
		3098
	],
	"./GetTokens/walkthrough/Walkthrough3.js": [
		66825,
		3098
	],
	"./GetTokens/walkthrough/Walkthrough4": [
		33656,
		9533
	],
	"./GetTokens/walkthrough/Walkthrough4.js": [
		33656,
		9533
	],
	"./GetTokens/walkthrough/Walkthrough5": [
		37756,
		7291
	],
	"./GetTokens/walkthrough/Walkthrough5.js": [
		37756,
		7291
	],
	"./GetTokens/walkthrough/Walkthrough6": [
		20969,
		7692,
		969
	],
	"./GetTokens/walkthrough/Walkthrough6.js": [
		20969,
		7692,
		969
	],
	"./GetTokens/walkthrough/Walkthrough7": [
		19065,
		1619
	],
	"./GetTokens/walkthrough/Walkthrough7.js": [
		19065,
		1619
	],
	"./GetTokens/walkthrough/Walkthrough8": [
		96898,
		1704
	],
	"./GetTokens/walkthrough/Walkthrough8.js": [
		96898,
		1704
	],
	"./GetTokens/walkthrough/Walkthrough9": [
		73660,
		2256
	],
	"./GetTokens/walkthrough/Walkthrough9.js": [
		73660,
		2256
	],
	"./GetTokens/walkthrough/WalkthroughIndex": [
		97063,
		7063
	],
	"./GetTokens/walkthrough/WalkthroughIndex.js": [
		97063,
		7063
	],
	"./Invoice/CreateInvoice": [
		8727,
		4570,
		6679,
		6023,
		8727
	],
	"./Invoice/CreateInvoice.tsx": [
		8727,
		4570,
		6679,
		6023,
		8727
	],
	"./Invoice/Invoice": [
		96585,
		5810,
		3940,
		6585
	],
	"./Invoice/Invoice.tsx": [
		96585,
		5810,
		3940,
		6585
	],
	"./Invoice/InvoiceId": [
		37431,
		5810,
		7431
	],
	"./Invoice/InvoiceId.tsx": [
		37431,
		5810,
		7431
	],
	"./Invoice/component/Column": [
		68981,
		8981
	],
	"./Invoice/component/Column.tsx": [
		68981,
		8981
	],
	"./Invoice/component/CustomerDetail": [
		86951,
		6951
	],
	"./Invoice/component/CustomerDetail.tsx": [
		86951,
		6951
	],
	"./Invoice/component/EnterItem": [
		94177,
		4177
	],
	"./Invoice/component/EnterItem.tsx": [
		94177,
		4177
	],
	"./Invoice/component/InvoiceButtonSection": [
		63619,
		3619
	],
	"./Invoice/component/InvoiceButtonSection.tsx": [
		63619,
		3619
	],
	"./Invoice/component/InvoiceDetail": [
		8761,
		8761
	],
	"./Invoice/component/InvoiceDetail.tsx": [
		8761,
		8761
	],
	"./Invoice/component/InvoiceForm": [
		4458,
		4570,
		6679,
		6023,
		4458
	],
	"./Invoice/component/InvoiceForm.tsx": [
		4458,
		4570,
		6679,
		6023,
		4458
	],
	"./Invoice/component/InvoiceTable": [
		69888,
		5810,
		9888
	],
	"./Invoice/component/InvoiceTable.tsx": [
		69888,
		5810,
		9888
	],
	"./Invoice/component/Items": [
		56985,
		5810,
		6985
	],
	"./Invoice/component/Items.tsx": [
		56985,
		5810,
		6985
	],
	"./Invoice/component/List": [
		64325,
		5810,
		4325
	],
	"./Invoice/component/List.tsx": [
		64325,
		5810,
		4325
	],
	"./Invoice/service/service": [
		11,
		11
	],
	"./Invoice/service/service.tsx": [
		11,
		11
	],
	"./NotFound/404": [
		96985
	],
	"./NotFound/404.tsx": [
		96985
	],
	"./Notifications/NotificationTable": [
		19422,
		5810,
		9422
	],
	"./Notifications/NotificationTable.tsx": [
		19422,
		5810,
		9422
	],
	"./Notifications/NotificationTableComponent": [
		5803,
		5810,
		5803
	],
	"./Notifications/NotificationTableComponent.tsx": [
		5803,
		5810,
		5803
	],
	"./Notifications/Notifications": [
		53541,
		5810,
		3541
	],
	"./Notifications/Notifications.tsx": [
		53541,
		5810,
		3541
	],
	"./Notifications/PreviewNotification": [
		44418,
		4418
	],
	"./Notifications/PreviewNotification.tsx": [
		44418,
		4418
	],
	"./Notifications/column": [
		72839,
		2839
	],
	"./Notifications/column.tsx": [
		72839,
		2839
	],
	"./Notifications/service": [
		80790,
		790
	],
	"./Notifications/service.tsx": [
		80790,
		790
	],
	"./PaymentLink/PaymentLink": [
		98167,
		5810,
		4570,
		8805,
		2057,
		1414,
		8167
	],
	"./PaymentLink/PaymentLink.tsx": [
		98167,
		5810,
		4570,
		8805,
		2057,
		1414,
		8167
	],
	"./PaymentLink/PaymentTransaction": [
		99232,
		5810,
		4570,
		8805,
		1414,
		9232
	],
	"./PaymentLink/PaymentTransaction.tsx": [
		99232,
		5810,
		4570,
		8805,
		1414,
		9232
	],
	"./PaymentLink/components/Column": [
		49357,
		9357
	],
	"./PaymentLink/components/Column.tsx": [
		49357,
		9357
	],
	"./PaymentLink/components/LinkModal": [
		93441,
		4570,
		8805,
		1414,
		3441
	],
	"./PaymentLink/components/LinkModal.tsx": [
		93441,
		4570,
		8805,
		1414,
		3441
	],
	"./PaymentLink/components/LinkTransaction": [
		74359,
		5810,
		4359
	],
	"./PaymentLink/components/LinkTransaction.tsx": [
		74359,
		5810,
		4359
	],
	"./PaymentLink/components/PaymentLinkTable": [
		62070,
		5810,
		2070
	],
	"./PaymentLink/components/PaymentLinkTable.tsx": [
		62070,
		5810,
		2070
	],
	"./PaymentLink/store/service": [
		94012,
		4012
	],
	"./PaymentLink/store/service.tsx": [
		94012,
		4012
	],
	"./QRPayment/QrPayment": [
		75655,
		5810,
		2057,
		8333,
		5655
	],
	"./QRPayment/QrPayment.tsx": [
		75655,
		5810,
		2057,
		8333,
		5655
	],
	"./QRPayment/components/QRPaymentModal": [
		5175,
		2057,
		5175
	],
	"./QRPayment/components/QRPaymentModal.tsx": [
		5175,
		2057,
		5175
	],
	"./QRPayment/components/QrCodeTable": [
		21471,
		5810,
		1471
	],
	"./QRPayment/components/QrCodeTable.tsx": [
		21471,
		5810,
		1471
	],
	"./QRPayment/service": [
		90812
	],
	"./QRPayment/service/": [
		90812
	],
	"./QRPayment/service/index": [
		90812
	],
	"./QRPayment/service/index.tsx": [
		90812
	],
	"./QRPayment/service/service": [
		20126
	],
	"./QRPayment/service/service.tsx": [
		20126
	],
	"./Settings/Settings": [
		65946,
		1081,
		3940,
		681,
		2057,
		7906,
		8384,
		4637,
		8636,
		5946
	],
	"./Settings/Settings.tsx": [
		65946,
		1081,
		3940,
		681,
		2057,
		7906,
		8384,
		4637,
		8636,
		5946
	],
	"./Settings/Types/types": [
		14254,
		4254
	],
	"./Settings/Types/types.tsx": [
		14254,
		4254
	],
	"./Settings/VerifyBusiness/Contact": [
		37224,
		7224
	],
	"./Settings/VerifyBusiness/Contact.tsx": [
		37224,
		7224
	],
	"./Settings/VerifyBusiness/Profile": [
		47834,
		8805,
		4605,
		7834
	],
	"./Settings/VerifyBusiness/Profile.tsx": [
		47834,
		8805,
		4605,
		7834
	],
	"./Settings/VerifyBusiness/RegisteredBusiness": [
		38462,
		4570,
		6679,
		6227,
		9829,
		6599
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/": [
		38462,
		4570,
		6679,
		6227,
		9829,
		6599
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents": [
		19829,
		4570,
		6679,
		6227,
		9829,
		1766
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents.tsx": [
		19829,
		4570,
		6679,
		6227,
		9829,
		1766
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/BusinessName": [
		79093,
		4570,
		9093
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/BusinessName.tsx": [
		79093,
		4570,
		9093
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/CoOperative": [
		40896,
		896
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/CoOperative.tsx": [
		40896,
		896
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/Company": [
		53494,
		3494
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/Company.tsx": [
		53494,
		3494
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/FreeZone": [
		52801,
		2801
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/FreeZone.tsx": [
		52801,
		2801
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/GovernmentEntity": [
		42946,
		2946
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/GovernmentEntity.tsx": [
		42946,
		2946
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/PrivateEntity": [
		91373,
		1373
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/PrivateEntity.tsx": [
		91373,
		1373
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/Trustees": [
		75915,
		5915
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/Documents/Trustees.tsx": [
		75915,
		5915
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/modals/GoogleAuthModal": [
		48208,
		2057,
		8208
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/modals/GoogleAuthModal.tsx": [
		48208,
		2057,
		8208
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/modals/OwnerModal": [
		96227,
		6679,
		6227,
		3143
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/components/modals/OwnerModal.tsx": [
		96227,
		6679,
		6227,
		3143
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/index": [
		38462,
		4570,
		6679,
		6227,
		9829,
		6599
	],
	"./Settings/VerifyBusiness/RegisteredBusiness/index.tsx": [
		38462,
		4570,
		6679,
		6227,
		9829,
		6599
	],
	"./Settings/VerifyBusiness/StarterBusiness": [
		10380,
		6679,
		380,
		7264
	],
	"./Settings/VerifyBusiness/StarterBusiness/": [
		10380,
		6679,
		380,
		7264
	],
	"./Settings/VerifyBusiness/StarterBusiness/components/Account": [
		16888,
		6888
	],
	"./Settings/VerifyBusiness/StarterBusiness/components/Account.tsx": [
		16888,
		6888
	],
	"./Settings/VerifyBusiness/StarterBusiness/components/Owner": [
		42875,
		6679,
		2875
	],
	"./Settings/VerifyBusiness/StarterBusiness/components/Owner.tsx": [
		42875,
		6679,
		2875
	],
	"./Settings/VerifyBusiness/StarterBusiness/index": [
		10380,
		6679,
		380,
		7264
	],
	"./Settings/VerifyBusiness/StarterBusiness/index.tsx": [
		10380,
		6679,
		380,
		7264
	],
	"./Settings/VerifyBusiness/VerifyBusiness": [
		99475,
		4570,
		8805,
		4605,
		6679,
		9337,
		6227,
		9829,
		380,
		9475
	],
	"./Settings/VerifyBusiness/VerifyBusiness.tsx": [
		99475,
		4570,
		8805,
		4605,
		6679,
		9337,
		6227,
		9829,
		380,
		9475
	],
	"./Settings/components": [
		99820,
		1081,
		681,
		7906,
		8384,
		4637,
		8636,
		9820
	],
	"./Settings/components/": [
		99820,
		1081,
		681,
		7906,
		8384,
		4637,
		8636,
		9820
	],
	"./Settings/components/AccountSettings/AccountSettings": [
		59196,
		9196
	],
	"./Settings/components/AccountSettings/AccountSettings.tsx": [
		59196,
		9196
	],
	"./Settings/components/ApiWebhooks/Api_Webhhoks": [
		18636,
		8636,
		3090
	],
	"./Settings/components/ApiWebhooks/Api_Webhhoks.tsx": [
		18636,
		8636,
		3090
	],
	"./Settings/components/BusinessDetails/BusinessDetails": [
		60801,
		801
	],
	"./Settings/components/BusinessDetails/BusinessDetails.tsx": [
		60801,
		801
	],
	"./Settings/components/Payments/BankAddNew": [
		59211,
		9211
	],
	"./Settings/components/Payments/BankAddNew.tsx": [
		59211,
		9211
	],
	"./Settings/components/Payments/BankPayoutFrom": [
		40035,
		35
	],
	"./Settings/components/Payments/BankPayoutFrom.tsx": [
		40035,
		35
	],
	"./Settings/components/Payments/ListBankAccount": [
		3707,
		3707
	],
	"./Settings/components/Payments/ListBankAccount.tsx": [
		3707,
		3707
	],
	"./Settings/components/Payments/ListMobileMoney": [
		21182,
		1182
	],
	"./Settings/components/Payments/ListMobileMoney.tsx": [
		21182,
		1182
	],
	"./Settings/components/Payments/MobileMoneyForm": [
		60592,
		7906,
		592
	],
	"./Settings/components/Payments/MobileMoneyForm.tsx": [
		60592,
		7906,
		592
	],
	"./Settings/components/Payments/Payment": [
		27123,
		7906,
		8384,
		7123
	],
	"./Settings/components/Payments/Payment.tsx": [
		27123,
		7906,
		8384,
		7123
	],
	"./Settings/components/Payments/PaymentDetails": [
		96029,
		6029
	],
	"./Settings/components/Payments/PaymentDetails.tsx": [
		96029,
		6029
	],
	"./Settings/components/Payments/PaymentModal": [
		66108,
		7906,
		8384
	],
	"./Settings/components/Payments/PaymentModal.tsx": [
		66108,
		7906,
		8384
	],
	"./Settings/components/Profile/Profile": [
		44637,
		1081,
		681,
		4637
	],
	"./Settings/components/Profile/Profile.tsx": [
		44637,
		1081,
		681,
		4637
	],
	"./Settings/components/Security/Security": [
		31748,
		2057,
		1748
	],
	"./Settings/components/Security/Security.tsx": [
		31748,
		2057,
		1748
	],
	"./Settings/components/index": [
		99820,
		1081,
		681,
		7906,
		8384,
		4637,
		8636,
		9820
	],
	"./Settings/components/index.tsx": [
		99820,
		1081,
		681,
		7906,
		8384,
		4637,
		8636,
		9820
	],
	"./Settings/store/service": [
		49628
	],
	"./Settings/store/service.ts": [
		49628
	],
	"./Settings/store/settingSlice": [
		62222
	],
	"./Settings/store/settingSlice.ts": [
		62222
	],
	"./Storefront/DeleteStoreModal": [
		31838,
		1838
	],
	"./Storefront/DeleteStoreModal.tsx": [
		31838,
		1838
	],
	"./Storefront/OrderDetails": [
		81795,
		5810,
		3940,
		7692,
		829,
		4985,
		9301,
		1795
	],
	"./Storefront/OrderDetails.tsx": [
		81795,
		5810,
		3940,
		7692,
		829,
		4985,
		9301,
		1795
	],
	"./Storefront/Product/OrderTable": [
		62441,
		5810,
		2441
	],
	"./Storefront/Product/OrderTable.tsx": [
		62441,
		5810,
		2441
	],
	"./Storefront/Product/Product": [
		37620,
		5810,
		8805,
		4605,
		1081,
		3940,
		5717,
		4180,
		6260,
		6080,
		7334,
		7620
	],
	"./Storefront/Product/Product.tsx": [
		37620,
		5810,
		8805,
		4605,
		1081,
		3940,
		5717,
		4180,
		6260,
		6080,
		7334,
		7620
	],
	"./Storefront/Product/components/Customize": [
		17334,
		8805,
		4605,
		5717,
		7334,
		2031
	],
	"./Storefront/Product/components/Customize.tsx": [
		17334,
		8805,
		4605,
		5717,
		7334,
		2031
	],
	"./Storefront/Product/components/Inventory": [
		46080,
		5810,
		1081,
		6260,
		6080,
		5244
	],
	"./Storefront/Product/components/Inventory.tsx": [
		46080,
		5810,
		1081,
		6260,
		6080,
		5244
	],
	"./Storefront/Product/components/Orders": [
		54563,
		5810,
		4563
	],
	"./Storefront/Product/components/Orders.tsx": [
		54563,
		5810,
		4563
	],
	"./Storefront/Product/components/Variant": [
		18643,
		5810,
		1081,
		6260,
		8643
	],
	"./Storefront/Product/components/Variant.tsx": [
		18643,
		5810,
		1081,
		6260,
		8643
	],
	"./Storefront/Product/components/VariationOption": [
		82164,
		2164
	],
	"./Storefront/Product/components/VariationOption.tsx": [
		82164,
		2164
	],
	"./Storefront/Product/components/modals/AddMedia": [
		83403,
		8805,
		4605,
		3403
	],
	"./Storefront/Product/components/modals/AddMedia.tsx": [
		83403,
		8805,
		4605,
		3403
	],
	"./Storefront/Product/components/modals/AddOptions": [
		90,
		90
	],
	"./Storefront/Product/components/modals/AddOptions.tsx": [
		90,
		90
	],
	"./Storefront/Product/components/modals/AddPrice": [
		17650,
		7650
	],
	"./Storefront/Product/components/modals/AddPrice.tsx": [
		17650,
		7650
	],
	"./Storefront/Product/components/modals/AddProductDescription": [
		25801,
		5801
	],
	"./Storefront/Product/components/modals/AddProductDescription.tsx": [
		25801,
		5801
	],
	"./Storefront/Product/components/modals/AddProductName": [
		4744,
		4744
	],
	"./Storefront/Product/components/modals/AddProductName.tsx": [
		4744,
		4744
	],
	"./Storefront/Product/components/modals/AddVariationOption": [
		21956,
		1956
	],
	"./Storefront/Product/components/modals/AddVariationOption.tsx": [
		21956,
		1956
	],
	"./Storefront/Product/components/modals/EditOption": [
		20680,
		680
	],
	"./Storefront/Product/components/modals/EditOption.tsx": [
		20680,
		680
	],
	"./Storefront/Product/components/modals/EditProductModal": [
		75226,
		1081,
		5226
	],
	"./Storefront/Product/components/modals/EditProductModal.tsx": [
		75226,
		1081,
		5226
	],
	"./Storefront/Product/components/modals/EditVariant": [
		26260,
		1081,
		6260
	],
	"./Storefront/Product/components/modals/EditVariant.tsx": [
		26260,
		1081,
		6260
	],
	"./Storefront/Product/components/types": [
		95895,
		5895
	],
	"./Storefront/Product/components/types.ts": [
		95895,
		5895
	],
	"./Storefront/Product/service": [
		34128,
		4128
	],
	"./Storefront/Product/service.ts": [
		34128,
		4128
	],
	"./Storefront/Storefront": [
		3833,
		4570,
		8805,
		4605,
		175,
		3833
	],
	"./Storefront/Storefront.tsx": [
		3833,
		4570,
		8805,
		4605,
		175,
		3833
	],
	"./Storefront/StorefrontData": [
		20342,
		5810,
		4570,
		8805,
		4605,
		3940,
		175,
		3171,
		5728,
		5547,
		7302,
		342
	],
	"./Storefront/StorefrontData.tsx": [
		20342,
		5810,
		4570,
		8805,
		4605,
		3940,
		175,
		3171,
		5728,
		5547,
		7302,
		342
	],
	"./Storefront/StorefrontDetails": [
		12613,
		2613
	],
	"./Storefront/StorefrontDetails.tsx": [
		12613,
		2613
	],
	"./Storefront/StorefrontStatus": [
		98505,
		8505
	],
	"./Storefront/StorefrontStatus.tsx": [
		98505,
		8505
	],
	"./Storefront/StorefrontStatus_Home": [
		58281,
		8281
	],
	"./Storefront/StorefrontStatus_Home.tsx": [
		58281,
		8281
	],
	"./Storefront/StorefrontTabs": [
		24231,
		5810,
		4570,
		8805,
		4605,
		3940,
		175,
		3171,
		5728,
		5547,
		7302,
		4231
	],
	"./Storefront/StorefrontTabs.tsx": [
		24231,
		5810,
		4570,
		8805,
		4605,
		3940,
		175,
		3171,
		5728,
		5547,
		7302,
		4231
	],
	"./Storefront/components/Ivoryshop/components/AddNewProduct": [
		70175,
		4570,
		8805,
		4605,
		175
	],
	"./Storefront/components/Ivoryshop/components/AddNewProduct.tsx": [
		70175,
		4570,
		8805,
		4605,
		175
	],
	"./Storefront/components/Ivoryshop/components/IvoryShopModal": [
		89372,
		9372
	],
	"./Storefront/components/Ivoryshop/components/IvoryShopModal.tsx": [
		89372,
		9372
	],
	"./Storefront/components/Ivoryshop/components/SelectProductModal": [
		84545,
		4545
	],
	"./Storefront/components/Ivoryshop/components/SelectProductModal.tsx": [
		84545,
		4545
	],
	"./Storefront/components/Ivoryshop/services": [
		65508,
		5508
	],
	"./Storefront/components/Ivoryshop/services/": [
		65508,
		5508
	],
	"./Storefront/components/Ivoryshop/services/index": [
		65508,
		5508
	],
	"./Storefront/components/Ivoryshop/services/index.tsx": [
		65508,
		5508
	],
	"./Storefront/components/TabsOrders": [
		7302,
		5810,
		4570,
		8805,
		4605,
		175,
		3171,
		5728,
		5547,
		7302
	],
	"./Storefront/components/TabsOrders/": [
		7302,
		5810,
		4570,
		8805,
		4605,
		175,
		3171,
		5728,
		5547,
		7302
	],
	"./Storefront/components/TabsOrders/ChangeBackgroundColor": [
		9201,
		9201
	],
	"./Storefront/components/TabsOrders/ChangeBackgroundColor.tsx": [
		9201,
		9201
	],
	"./Storefront/components/TabsOrders/Customize": [
		25547,
		5547,
		8214
	],
	"./Storefront/components/TabsOrders/Customize.tsx": [
		25547,
		5547,
		8214
	],
	"./Storefront/components/TabsOrders/Orders": [
		3438,
		5810,
		3438
	],
	"./Storefront/components/TabsOrders/Orders.tsx": [
		3438,
		5810,
		3438
	],
	"./Storefront/components/TabsOrders/Orders/DeleteDeliveryAgentModal": [
		81106,
		9301,
		9290
	],
	"./Storefront/components/TabsOrders/Orders/DeleteDeliveryAgentModal.tsx": [
		81106,
		9301,
		9290
	],
	"./Storefront/components/TabsOrders/Orders/DeliveryDetails": [
		96874,
		9301,
		9290
	],
	"./Storefront/components/TabsOrders/Orders/DeliveryDetails.tsx": [
		96874,
		9301,
		9290
	],
	"./Storefront/components/TabsOrders/Orders/OrderTable": [
		54985,
		5810,
		829,
		4985
	],
	"./Storefront/components/TabsOrders/Orders/OrderTable.tsx": [
		54985,
		5810,
		829,
		4985
	],
	"./Storefront/components/TabsOrders/Orders/components/About": [
		33631,
		3631
	],
	"./Storefront/components/TabsOrders/Orders/components/About.tsx": [
		33631,
		3631
	],
	"./Storefront/components/TabsOrders/Orders/components/AddAgent": [
		30528,
		528
	],
	"./Storefront/components/TabsOrders/Orders/components/AddAgent.tsx": [
		30528,
		528
	],
	"./Storefront/components/TabsOrders/Orders/components/AddContact": [
		36471,
		6471
	],
	"./Storefront/components/TabsOrders/Orders/components/AddContact.tsx": [
		36471,
		6471
	],
	"./Storefront/components/TabsOrders/Orders/components/AddMessage": [
		14630,
		4630
	],
	"./Storefront/components/TabsOrders/Orders/components/AddMessage.tsx": [
		14630,
		4630
	],
	"./Storefront/components/TabsOrders/Orders/components/AddSocialMedia": [
		1613,
		1613
	],
	"./Storefront/components/TabsOrders/Orders/components/AddSocialMedia.tsx": [
		1613,
		1613
	],
	"./Storefront/components/TabsOrders/Orders/components/CancelOrder": [
		12315,
		2315
	],
	"./Storefront/components/TabsOrders/Orders/components/CancelOrder.tsx": [
		12315,
		2315
	],
	"./Storefront/components/TabsOrders/Orders/components/MarkDelivered": [
		93980,
		3980
	],
	"./Storefront/components/TabsOrders/Orders/components/MarkDelivered.tsx": [
		93980,
		3980
	],
	"./Storefront/components/TabsOrders/Orders/components/Shareable": [
		3168,
		3168
	],
	"./Storefront/components/TabsOrders/Orders/components/Shareable.tsx": [
		3168,
		3168
	],
	"./Storefront/components/TabsOrders/Orders/services": [
		99110,
		9110
	],
	"./Storefront/components/TabsOrders/Orders/services/": [
		99110,
		9110
	],
	"./Storefront/components/TabsOrders/Orders/services/index": [
		99110,
		9110
	],
	"./Storefront/components/TabsOrders/Orders/services/index.ts": [
		99110,
		9110
	],
	"./Storefront/components/TabsOrders/Orders/types": [
		16938,
		6938
	],
	"./Storefront/components/TabsOrders/Orders/types.ts": [
		16938,
		6938
	],
	"./Storefront/components/TabsOrders/ProductItems/DeleteProductModal": [
		64578,
		4578
	],
	"./Storefront/components/TabsOrders/ProductItems/DeleteProductModal.tsx": [
		64578,
		4578
	],
	"./Storefront/components/TabsOrders/ProductItems/ProductItems": [
		37135,
		3171,
		575
	],
	"./Storefront/components/TabsOrders/ProductItems/ProductItems.tsx": [
		37135,
		3171,
		575
	],
	"./Storefront/components/TabsOrders/Products": [
		26150,
		4570,
		8805,
		4605,
		175,
		3171,
		6150
	],
	"./Storefront/components/TabsOrders/Products.tsx": [
		26150,
		4570,
		8805,
		4605,
		175,
		3171,
		6150
	],
	"./Storefront/components/TabsOrders/ShopSettings": [
		73420,
		5728,
		3420
	],
	"./Storefront/components/TabsOrders/ShopSettings/": [
		73420,
		5728,
		3420
	],
	"./Storefront/components/TabsOrders/ShopSettings/AfterPurchaseSettings": [
		44793,
		4793
	],
	"./Storefront/components/TabsOrders/ShopSettings/AfterPurchaseSettings.tsx": [
		44793,
		4793
	],
	"./Storefront/components/TabsOrders/ShopSettings/DeliverySettings": [
		65728,
		5728
	],
	"./Storefront/components/TabsOrders/ShopSettings/DeliverySettings.tsx": [
		65728,
		5728
	],
	"./Storefront/components/TabsOrders/ShopSettings/ShippingRegionComponent": [
		83434,
		3434
	],
	"./Storefront/components/TabsOrders/ShopSettings/ShippingRegionComponent.tsx": [
		83434,
		3434
	],
	"./Storefront/components/TabsOrders/ShopSettings/index": [
		73420,
		5728,
		3420
	],
	"./Storefront/components/TabsOrders/ShopSettings/index.tsx": [
		73420,
		5728,
		3420
	],
	"./Storefront/components/TabsOrders/ShopSettings/service": [
		80386,
		386
	],
	"./Storefront/components/TabsOrders/ShopSettings/service.ts": [
		80386,
		386
	],
	"./Storefront/components/TabsOrders/index": [
		7302,
		5810,
		4570,
		8805,
		4605,
		175,
		3171,
		5728,
		5547,
		7302
	],
	"./Storefront/components/TabsOrders/index.tsx": [
		7302,
		5810,
		4570,
		8805,
		4605,
		175,
		3171,
		5728,
		5547,
		7302
	],
	"./Storefront/service": [
		73652,
		3652
	],
	"./Storefront/service.ts": [
		73652,
		3652
	],
	"./Swap/Swap": [
		43248,
		5810,
		829,
		1210,
		3248
	],
	"./Swap/Swap.tsx": [
		43248,
		5810,
		829,
		1210,
		3248
	],
	"./Swap/components/Column": [
		75003,
		5003
	],
	"./Swap/components/Column.tsx": [
		75003,
		5003
	],
	"./Swap/components/SwapCoin": [
		1605,
		829,
		1605
	],
	"./Swap/components/SwapCoin.tsx": [
		1605,
		829,
		1605
	],
	"./Swap/components/SwapTransactionTable": [
		55465,
		5810,
		5465
	],
	"./Swap/components/SwapTransactionTable.tsx": [
		55465,
		5810,
		5465
	],
	"./Swap/service": [
		26635,
		6635
	],
	"./Swap/service.tsx": [
		26635,
		6635
	],
	"./Swap/types": [
		23314,
		3314
	],
	"./Swap/types.tsx": [
		23314,
		3314
	],
	"./Transaction/Transaction": [
		35191,
		5810,
		5191
	],
	"./Transaction/Transaction.tsx": [
		35191,
		5810,
		5191
	],
	"./Transaction/TransactionDetail": [
		36406,
		6406
	],
	"./Transaction/TransactionDetail.tsx": [
		36406,
		6406
	],
	"./Transaction/components/Column": [
		26615,
		6615
	],
	"./Transaction/components/Column.tsx": [
		26615,
		6615
	],
	"./Transaction/components/TransactionInformation": [
		55499,
		5499
	],
	"./Transaction/components/TransactionInformation.tsx": [
		55499,
		5499
	],
	"./Transaction/store/service": [
		17194,
		7194
	],
	"./Transaction/store/service.tsx": [
		17194,
		7194
	],
	"./Transfer/Transfer": [
		9579,
		5810,
		681,
		829,
		1210,
		7562,
		5153,
		9579
	],
	"./Transfer/Transfer.tsx": [
		9579,
		5810,
		681,
		829,
		1210,
		7562,
		5153,
		9579
	],
	"./Transfer/TransferDetail": [
		1262,
		1262
	],
	"./Transfer/TransferDetail.tsx": [
		1262,
		1262
	],
	"./Transfer/components/Column": [
		93282,
		3282
	],
	"./Transfer/components/Column.tsx": [
		93282,
		3282
	],
	"./Transfer/components/TransferDetailTable": [
		60765,
		765
	],
	"./Transfer/components/TransferDetailTable.tsx": [
		60765,
		765
	],
	"./Transfer/components/TransferList": [
		64456,
		5810,
		4456
	],
	"./Transfer/components/TransferList.tsx": [
		64456,
		5810,
		4456
	],
	"./VirtualAccount/VirtualAccount": [
		25520,
		5810,
		5520
	],
	"./VirtualAccount/VirtualAccount.tsx": [
		25520,
		5810,
		5520
	],
	"./VirtualAccount/components/Column": [
		3461,
		3461
	],
	"./VirtualAccount/components/Column.tsx": [
		3461,
		3461
	],
	"./Wallet/VirtualAccount": [
		96840,
		5810,
		6840
	],
	"./Wallet/VirtualAccount.tsx": [
		96840,
		5810,
		6840
	],
	"./Wallet/Wallet": [
		61116,
		5810,
		829,
		5590,
		1116
	],
	"./Wallet/Wallet.tsx": [
		61116,
		5810,
		829,
		5590,
		1116
	],
	"./Wallet/components/Column": [
		72906,
		2906
	],
	"./Wallet/components/Column.tsx": [
		72906,
		2906
	],
	"./Wallet/components/CryptoWallet": [
		28689,
		829,
		8689
	],
	"./Wallet/components/CryptoWallet.tsx": [
		28689,
		829,
		8689
	],
	"./Wallet/components/FiatTransactions": [
		67818,
		5810,
		7818
	],
	"./Wallet/components/FiatTransactions.tsx": [
		67818,
		5810,
		7818
	],
	"./Wallet/components/FiatWallets": [
		5590,
		5590,
		1100
	],
	"./Wallet/components/FiatWallets.tsx": [
		5590,
		5590,
		1100
	],
	"./Wallet/components/GenerateVAModal": [
		60115,
		115
	],
	"./Wallet/components/GenerateVAModal.tsx": [
		60115,
		115
	],
	"./Wallet/components/VirtualAccountInfoModal": [
		70307,
		307
	],
	"./Wallet/components/VirtualAccountInfoModal.tsx": [
		70307,
		307
	],
	"./Wallet/store/service": [
		84176,
		4176
	],
	"./Wallet/store/service.ts": [
		84176,
		4176
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67835;
module.exports = webpackAsyncContext;